import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

// react-confirm-alert's overlay defaults to z-index 99, which puts it BELOW
// Bootstrap modals (~1055). Raise it once so confirmations opened from inside
// a modal stack on top of it.
if (typeof document !== 'undefined' && !document.getElementById('confirm-alert-zindex-fix')) {
    const style = document.createElement('style');
    style.id = 'confirm-alert-zindex-fix';
    style.innerHTML = '.react-confirm-alert-overlay { z-index: 2000 !important; }';
    document.head.appendChild(style);
}


export function showConfirmDialog(description) {
    return new Promise((resolve) => {
        const options = {
            title: 'Are you sure?',
            message: description,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        // Resolve the promise with true when "Yes" is clicked
                        resolve(true);
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        // Resolve the promise with false when "No" is clicked
                        resolve(false);
                    }
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => {
            },
            afterClose: () => {
            },
            onClickOutside: () => {
            },
            onKeypress: () => {
            },
            onKeypressEscape: () => {
            },
            overlayClassName: 'overlay-custom-class-name',
        };

        confirmAlert(options);
    });
}


